import React, { Component } from 'react';
import { APP_CONST } from '../../../../../../constants';
import { GeckoFields, GeckoBtn } from '../../../../../../components';
import IntlTelInput from 'react-intl-tel-input';
import 'react-intl-tel-input/dist/main.css';
import './style.css';

export class PhoneNumberRequired extends Component {
    state = {
        valid: false,
        raw_value: null,
        meta: {},
        formated_value: null,
    }

    constructor(props) {
        super(props);

        this.handleChange = this.handleChange.bind(this);
        this.handleChangeFlag = this.handleChangeFlag.bind(this);
        this.submit = this.submit.bind(this);
    }

    handleChange(valid, raw_value, meta, formated_value) {
        this.setState({
            valid: valid,
            raw_value: raw_value,
            meta: meta,
            formated_value: formated_value,
        });
    }

    handleChangeFlag(raw_value, meta, formated_value, valid) {
        this.setState({
            valid: valid,
            raw_value: raw_value,
            meta: meta,
            formated_value: formated_value,
        });
    }

    submit() {
        if (!this.state.formated_value || this.state.formated_value === '') {
            return;
        }

        if (!this.state.valid) {
            this.props.setAlert('Invalid Mobile Number');
            return;
        }

        // remove spaces and dashes
        let number = this.state.formated_value;
        number = number.split(' ').join('');
        number = number.split('-').join('');

        return this.props.submit(number);
    }

    render() {
        return (
            <div>
                <div className="reason-description">You must provide your mobile number before setting up two factor authentication</div>

                <form className="gecko-fields">
                    <div className="form-group col-12" style={{flex: '0 0 100%'}}>
                        <div className="gecko-field gecko-field-type-tel d-flex flex-column">
                            <label htmlFor="field_phone_number" className="control-label"><span>Mobile Phone Number</span></label>
                            <IntlTelInput
                                containerClassName="intl-tel-input"
                                inputClassName="col-sm form-control gecko-ui-material"
                                onPhoneNumberChange={this.handleChange}
                                onSelectFlag={this.handleChangeFlag}
                            />
                        </div>
                    </div>
                </form>

                <GeckoBtn 
                    name={'Save Number'}
                    icon={'save'}
                    type={APP_CONST.BTN_TYPE_SUCCESS}
                    className={'float-right savePhoneNumberButton'}
                    handler={this.submit}
                />
            </div>
        );
    }
}

PhoneNumberRequired.defaultProps = {
    submit: () => null,
    setAlert: () => null,
}

export default PhoneNumberRequired;